import React from 'react';
import Badge from './Badge.jsx';

export function ProductCard({
  image,
  title,
  price,
  tags = [],
  featured = false,
  actions,
  className = '',
  ...props
}) {
  return (
    <div className={`relative bg-surface border border-border rounded-xl shadow-md overflow-hidden flex flex-col ${featured ? 'ring-2 ring-accent' : ''} ${className}`} {...props}>
      {featured && (
        <span className="absolute top-3 left-3 z-10">
          <Badge variant="accent" size="sm">Coup de cœur</Badge>
        </span>
      )}
      <div className="aspect-w-1 aspect-h-1 bg-background flex items-center justify-center overflow-hidden">
        {image ? (
          <img src={image} alt={title} className="object-cover w-full h-full transition-transform duration-300 hover:scale-105" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-4xl text-accent/30">🍞</div>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-heading text-lg font-bold text-primary mb-1 truncate">{title}</h3>
        <div className="flex flex-wrap gap-1 mb-2">
          {tags.map((tag) => (
            <Badge key={tag} variant="outline" size="sm">{tag}</Badge>
          ))}
        </div>
        <div className="mt-auto flex items-center justify-between">
          <span className="text-xl font-bold text-accent">{price}</span>
          {actions && <div>{actions}</div>}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
